import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import * as Highcharts from "highcharts/highcharts-gantt";
import { Options } from 'highcharts';
import { CommonService } from 'src/app/services/common.service';
import { KpimasterService } from 'src/app/services/kpimaster.service';
import { UserManagementService } from 'src/app/services/usermanagement.service';
import { ToastrService } from 'ngx-toastr';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TranslaterService } from 'src/app/services/translater.service';

@Component({
  selector: 'app-genealogy-dashboard-version2',
  templateUrl: './genealogy-dashboard-version2.component.html',
  styleUrls: ['./genealogy-dashboard-version2.component.scss']
})
export class GenealogyDashboardComponentVersion2 implements OnInit {

  breadcrumList: any = [];
  options!: Options;
  chartOutputLossWaterfall!: any;

  gridApi: any;
  gridColumnApi: any;
  gridOptions: any = {
    defaultColDef: {
      resizable: true,
      sortable: true,
      filter: 'agTextColumnFilter',
      floatingFilterComponentParams: {
        suppressFilterButton: false,
      },
      filterParams: { newRowsAction: 'keep' },
    },
  }
  ColumnDefs = [
    { field: 'BatchNo', headerName: 'Batch No', minWidth: 300 },
    { field: 'PU_Desc', headerName: 'Machine', minWidth: 200 },
    { field: 'Result', headerName: 'Quantity', minWidth: 100 }
  ];
  paginationPageSize: any = 10;
  rowData: any = [
  ];
  barCode: string;
  Highcharts: typeof Highcharts = Highcharts;

  chartOptions: Highcharts.Options;
  chartValues: any = [];
  chart: boolean = false;
  IsAccess: any;
  IsWrite: any;
  languageDir = 'ltr';
  langObj: any = {};
  moduleId!: any;
  pageId!: any;

  constructor(private commonService: CommonService, private cd: ChangeDetectorRef, private kpiMaster: KpimasterService, private usermanagementService: UserManagementService, private toaster: ToastrService, public translate: TranslateService, public translater: TranslaterService) {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => { event.lang === 'ar' ?  this.languageDir = 'rtl' :  this.languageDir = 'ltr';this.getLangWords();})
  }

  ngOnInit(): void {
    // this.waterfallMonthlyOutputLoss();
    // this.productionOutputByBarcode();
    this.GetBreadcrumList();
    this.GetMenuAccess();
  }

  public getLangWords() {
    const key = {
      ModuleId: this.moduleId,
      PageId: this.pageId,
      LanguageId: this.translate.currentLang === 'en' ? 1 : this.translate.currentLang === 'ar' ? 2 : this.translate.currentLang === 'fr' ? 3 : this.translate.currentLang === 'sp' ? 4 : this.translate.currentLang === 'gr' ? 5 : this.translate.currentLang === 'du' ? 6 : 1
    };
    this.translater.getLangWords(key).subscribe((res: any) => {
      let obj: any = {};
      res.tagList.map((elem: any) => {
        obj[elem.tagName] = elem.translatedValue;
      });
      this.langObj = obj;
    });
  }

  GetMenuAccess() {
    const key = {
      Id: localStorage.getItem('O3RightMenuId')
    };
    this.kpiMaster.GetMenuAccess(key).subscribe((data: any) => {
      // this.permisson = data;
      this.IsAccess = data.IsAccess;
      this.IsWrite = data.IsWrite;
    },
      (error) => {
        this.toaster.error('Error', error.error.message);
      }
    );
  }

  GetBreadcrumList(): any {
    const obj = {
      MenuId: localStorage.getItem('O3RightMenuId') === null ? 1 : localStorage.getItem('O3RightMenuId')
    };
    // tslint:disable-next-line: align
    this.usermanagementService.GetBreadcrumList(obj).subscribe((data: any) => {
      this.breadcrumList = data.BreadcrumList;
      this.moduleId = this.breadcrumList[0].id;
      this.pageId = this.breadcrumList[this.breadcrumList.length - 1].id;
      this.getLangWords();
      console.log(data.BreadcrumList);
    }, (error) => {
      this.toaster.error('Error', error.ErrorMessage);
    });
  }

  productionOutputByBarcode() {
    const data = { "barcode": this.barCode }
    this.commonService.productionOutputByBarcode(data).subscribe((res: any) => {
      if (res) {
        // this.barCode = '';
        this.rowData = res.data;
        this.rowData = this.rowData.sort((a, b) => a.BI_Id > b.BI_Id ? -1 : 1);
        const ind = this.rowData.findIndex(val => val.BatchNo == this.barCode);
        this.rowData = this.rowData.slice(ind);
        this.chartValues = [];
        this.rowData.forEach((val: any, index) => {
          const obj = {
            BatchNo: val.BatchNo,
            name: val.PU_Desc,
            // id: index,
            id: val.BatchNo.toLowerCase(),
            start: index * 200,
            end: (index + 1) * 200,
            result: val.Result
          };
          if (index != 0) {
            obj['dependency'] = this.chartValues[index - 1].id;
            obj['parent'] = this.chartValues[index - 1].id;
          }
          this.chartValues.push(obj);
        })
        this.chart = true;
        this.waterfallMonthlyOutputLoss();
        this.cd.detectChanges();
      }
    }, err => {
      console.log(err)
    })
  }

  waterfallMonthlyOutputLoss() {
    Highcharts.ganttChart('container', {
      chart: {
        height: 400
      },
      title: {
        text: 'Genealogy Dashboard'
      },
      lang: {
        accessibility: {
          axis: {
            xAxisDescriptionPlural: 'The chart has a two-part X axis showing time in both week numbers and days.'
          }
        }
      },
      xAxis: [{
        min: 0,
        max: this.chartValues.length * 200,
        // type: 'category',
        gridLineWidth: 0,
        visible: false,
        grid: {
          enabled: false,
        }
      }, {
        visible: false,
        opposite: false
      }],
      tooltip: {
        enabled: false,
        pointFormat: '<span>{point.BatchNo} - ({point.result} QTY)</span>'
      },
      // plotOptions: {
      //   bar: {
      //     pointWidth: 80,
      //     dataLabels: {
      //       enabled: true,
      //       // format: '{point.value}'
      //       formatter: (value:any) => {
      //         console.log(value)
      //         return value.value.name;
      //       }
      //     }
      //   }
      // },
      plotOptions: {
        series: {
          dataLabels: {
            inside: true,
            align: 'center',
            crop: false,
            // overflow: 'none',
            y: -40,
            enabled: true,
            color: `{this.point['color']}`,
            formatter: function () {
              return `${this.point['BatchNo']} - (${this.point['result']} Qty)`;
            }
          }
        }
      },
      series: [
        {
          name: 'Genealogy Dashboard V2',
          data: this.chartValues,
          type: 'gantt',
          colors: ['#2f7ed8', '#0d233a', '#492970', '#910000', '#1aadce']
        }
      ]
    })
  }

  onGridReady(params: any): any {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridOptions.api.sizeColumnsToFit();
  }

}
